// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2vGmJ","fullScreen":"Loader_fullScreen__iXVlU"};